var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    ref: "biographyBoxRef",
    staticClass: "biography-main page-main"
  }, [_c('div', {
    staticClass: "biography-tab",
    class: [_vm.showTab && 'active', _vm.isTab == 1 && 'noTab']
  }, _vm._l(_vm.tabList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "biography-tab-item",
      class: item.value == _vm.isTab && 'active',
      on: {
        "click": function ($event) {
          return _vm.onTab(item);
        }
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 0), _c('div', {
    staticClass: "biography-tab-wrapper"
  }, [_c('div', {
    ref: "tabInner",
    staticClass: "biography-tab-inner",
    style: {
      transform: `translateX(${_vm.translateX}px)`,
      transition: _vm.transitionStyle
    },
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd,
      "mousedown": _vm.onTouchStart,
      "mousemove": _vm.onTouchMove,
      "mouseup": _vm.onTouchEnd,
      "mouseleave": _vm.onTouchEnd
    }
  }, [_c('div', {
    staticClass: "biography-tab-page"
  }, [_c('div', {
    staticClass: "biography-box"
  }, [_c('div', {
    staticClass: "biggraphy-bg",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/bio/bio-bg.jpg`)}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "biography-box-main"
  }, [_c('div', {
    staticClass: "biography-lift"
  }, [_c('div', {
    staticClass: "bipgraphy-headimg"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-avatar-head.png`),
      "alt": ""
    }
  })]), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "biography-club"
  }, [_vm._m(2), _c('div', {
    staticClass: "biography-club-list wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.8s"
    }
  }, [_c('div', {
    staticClass: "biography-club-img",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/bio/bio-club-bg.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "biography-club-main"
  }, [_c('div', {
    staticClass: "biography-club-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-club-icon-1.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-club-item__title"
  }, [_vm._v("Appearances")]), _c('div', {
    staticClass: "biography-club-item__num"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": 902
    }
  })], 1), _c('div', {
    staticClass: "biography-club-item__sub",
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(42) + 'rem' : _vm.remTran(36) + 'rem'
    }
  }, [_vm._v("The most in the club's history")])]), _c('div', {
    staticClass: "biography-club-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-club-icon-2.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-club-item__title"
  }, [_vm._v("Goals")]), _c('div', {
    staticClass: "biography-club-item__num"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": 33
    }
  })], 1), _c('div', {
    staticClass: "biography-club-item__sub",
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(42) + 'rem' : _vm.remTran(36) + 'rem'
    }
  }, [_vm._v("Including 29 in Serie A")])]), _c('div', {
    staticClass: "biography-club-item lea"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-club-icon-3.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-club-item__title"
  }, [_vm._v("Trophies")]), _c('div', {
    staticClass: "biography-club-item__num"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": 26
    }
  })], 1), _c('div', {
    staticClass: "biography-club-item-include"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Including:")]), _c('p', {
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(46) + 'rem' : _vm.remTran(40) + 'rem'
    },
    attrs: {
      "index-data": "5x"
    }
  }, [_vm._v("UEFA Champions League titles")]), _c('p', {
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(46) + 'rem' : _vm.remTran(40) + 'rem'
    },
    attrs: {
      "index-data": "7x"
    }
  }, [_vm._v("Serie A titles")]), _c('p', {
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(46) + 'rem' : _vm.remTran(40) + 'rem'
    },
    attrs: {
      "index-data": "5x"
    }
  }, [_vm._v("Italian Super Cups")]), _c('p', {
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(46) + 'rem' : _vm.remTran(40) + 'rem'
    },
    attrs: {
      "index-data": "2x"
    }
  }, [_vm._v("Intercontinental Cups")]), _c('p', {
    style: {
      fontSize: _vm.devicePixelRatio > 1.5 ? _vm.remTran(46) + 'rem' : _vm.remTran(40) + 'rem'
    },
    attrs: {
      "index-data": "1x"
    }
  }, [_vm._v("FIFA Club World Cup")])])]), _c('div', {
    staticClass: "biography-club-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-club-icon-4.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-club-item__title"
  }, [_vm._v("Leadership")]), _c('div', {
    staticClass: "biography-club-item__num"
  }, [_vm._v("Captain")]), _c('div', {
    staticClass: "biography-club-item__sub",
    style: {
      fontSize: _vm.devicePixelRatio > 1 ? _vm.remTran(42) + 'rem' : _vm.remTran(36) + 'rem'
    }
  }, [_vm._v("Assumed the captain's armband in 1997")])]), _c('div', {
    staticClass: "biography-club-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-club-icon-5.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-club-item__title"
  }, [_vm._v("Honor")]), _c('div', {
    staticClass: "biography-club-item__num"
  }, [_vm._v("Defender")]), _c('div', {
    staticClass: "biography-club-item__sub",
    style: {
      fontSize: _vm.devicePixelRatio > 1 ? _vm.remTran(42) + 'rem' : _vm.remTran(36) + 'rem'
    }
  }, [_vm._v("Named UEFA Club Defender of the Year at age 39")])])])])]), _c('div', {
    staticClass: "biography-avatar wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.9s"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-avatar-img.png`),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "biography-inter"
  }, [_vm._m(3), _c('div', {
    staticClass: "biography-inter-list wow fadeInUp",
    attrs: {
      "data-wow-duration": "1.1s"
    }
  }, [_c('div', {
    staticClass: "biography-inter-img",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/bio/bio-inter-bg.png`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "biography-inter-main"
  }, [_c('div', {
    staticClass: "biography-inter-item app"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-inter-icon-1.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-inter-item__title"
  }, [_vm._v("Appearances")]), _c('div', {
    staticClass: "biography-inter-item__num"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": 126
    }
  })], 1), _c('div', {
    staticClass: "biography-inter-item__sub big"
  }, [_vm._v("126 appearances and 7 goals for Italy")])]), _c('div', {
    staticClass: "biography-inter-item lea"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-inter-icon-2.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-inter-item__title"
  }, [_vm._v("Tournaments")]), _c('div', {
    staticClass: "biography-inter-item__num"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": 7
    }
  })], 1), _c('div', {
    staticClass: "biography-inter-item__sub"
  }, [_vm._v("Played in 4 World Cups and 3 UEFA Euros")]), _vm._m(4)]), _c('div', {
    staticClass: "biography-inter-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-inter-icon-3.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-inter-item__title"
  }, [_vm._v("Leadership")]), _c('div', {
    staticClass: "biography-inter-item__num"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": 8
    }
  })], 1), _c('div', {
    staticClass: "biography-inter-item__sub"
  }, [_vm._v("Team captain for 8 years (75 matches)")])]), _c('div', {
    staticClass: "biography-inter-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-inter-icon-4.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "biography-inter-item__title"
  }, [_vm._v("Honor")]), _c('div', {
    staticClass: "biography-inter-item__num all"
  }, [_vm._v("All-Star Game")]), _c('div', {
    staticClass: "biography-inter-item__sub"
  }, [_vm._v("Named in multiple All-Star Teams for major tournaments")])])])])]), _c('div', {
    staticClass: "biography-post"
  }, [_vm._m(5), _c('div', {
    staticClass: "biography-post-list"
  }, [_c('div', {
    staticClass: "biography-post-item wow fadeInUp",
    attrs: {
      "data-wow-duration": "1.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-badge.png`),
      "alt": ""
    }
  }), _vm._v("Named in the FIFA 100 list of legendary players")]), _c('div', {
    staticClass: "biography-post-item wow fadeInUp",
    attrs: {
      "data-wow-duration": "1.4s"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-badge.png`),
      "alt": ""
    }
  }), _vm._v("Named in the FIFA World Cup Dream Team")]), _c('div', {
    staticClass: "biography-post-item wow fadeInUp",
    attrs: {
      "data-wow-duration": "1.5s"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-badge.png`),
      "alt": ""
    }
  }), _vm._v("2nd place in the 1995 FIFA World Player of the Year")]), _c('div', {
    staticClass: "biography-post-item wow fadeInUp",
    attrs: {
      "data-wow-duration": "1.6s"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-badge.png`),
      "alt": ""
    }
  }), _vm._v("3rd place in the 2004 Ballon d'Or")]), _c('div', {
    staticClass: "biography-post-item wow fadeInUp",
    attrs: {
      "data-wow-duration": "1.7s"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/bio/bio-badge.png`),
      "alt": ""
    }
  }), _vm._v("Inducted into the Italian Football Hall of Fame in 2012")])])])])])]), _c('div', {
    staticClass: "biography-tab-page"
  }, [_c('div', {
    staticClass: "biography-photo"
  }, _vm._l(12, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "biography-photo-img"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isTab == 1 || _vm.isTab == 0 && index <= 2,
        expression: "isTab == 1 || (isTab == 0 && index <= 2)"
      }],
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/intro/${index + 1}.jpg`)
      }
    })]);
  }), 0)])])])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography-head wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(" PAOLO "), _c('p', [_vm._v("MALDINI")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography-intro"
  }, [_c('div', {
    staticClass: "biography-intro__title wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_c('span', [_vm._v("Personal Life")])]), _c('div', {
    staticClass: "biography-intro__value wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.6s"
    }
  }, [_vm._v("Paolo Maldini was born on June 26, 1968, in Milan, Italy. He is regarded as one of the greatest defenders in football history. He spent his entire 25-year professional career at AC Milan, following in the footsteps of his father, Cesare Maldini. After retiring, Paolo served as AC Milan's technical director (2018–2023) and became co-owner of Inter Miami CF.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography__title wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.7s"
    }
  }, [_c('span', [_vm._v("Club Career")]), _vm._v(" A career at AC Milan ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography__title wow fadeInLeft",
    attrs: {
      "data-wow-duration": "1s"
    }
  }, [_c('span', [_vm._v("International Career")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography-inter-item-include all"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Reached:")]), _c('p', {
    attrs: {
      "index-data": "1994"
    }
  }, [_vm._v("World Cup Final")]), _c('p', {
    attrs: {
      "index-data": "2000"
    }
  }, [_vm._v("Euro Final")]), _c('p', {
    attrs: {
      "index-data": "1990"
    }
  }, [_vm._v("World Cup Semifinals")]), _c('p', {
    attrs: {
      "index-data": "1988"
    }
  }, [_vm._v("Euro Semifinals")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "biography__title wow fadeInLeft",
    attrs: {
      "data-wow-duration": "1.2s"
    }
  }, [_c('span', [_vm._v("Post-Retirement")]), _vm._v(" Maldini has received numerous honors ")]);
}];
export { render, staticRenderFns };